export const Q_SPLITR_CAMPAIGN_ID = "s-campaign-id"
export const Q_SPLITR_DEVICE_NAME = "s-device-name"

export const SPLITR_CAMPAIGN_ID = "splitr_campaign_id"
export const SPLITR_DEVICE_NAME = "splitr_device_name"
